module.exports = "https://tutorchat.chegg.com/static/media/ic-screenshot.744bfd36.svg";